import React from 'react';

const WithRole = ({ roles, children, ...other }) => {
  return withRoles(roles) ?
          React.cloneElement(React.Children.only(children), {
            ...other,
          }) : <span></span>;
};

export const withRoles = (roles) => {
  const loggedUser = JSON.parse(localStorage.getItem('loggedUser'));
  if (!loggedUser) {
    return false;
  }

  const toBeChecked = Array.isArray(roles) ? roles : [roles];
  const containedRoles = toBeChecked.filter(r => loggedUser.roles.indexOf(r) >= 0);

  return containedRoles.length > 0;
};

export default WithRole;



// WEBPACK FOOTER //
// ./src/main/components/container/WithRole.js